import React, { useState } from 'react';
import { IconButton, InputAdornment, TextField, useTheme } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useTranslation } from 'react-i18next';

interface PasswordTextInputProps {
  required?: boolean;
  autoFocus?: boolean;
  fullWidth?: boolean;
  name: string;
  autoComplete?: string;
  value: string;
  label: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error?: boolean;
}
export function PasswordTextInput({
  required,
  fullWidth,
  autoFocus,
  name,
  value,
  label,
  onChange,
  autoComplete,
  error,
}: PasswordTextInputProps) {
  const [showPassword, setShowPassword] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault();
  };

  const togglePasswordVisibility = () => {
    return showPassword ? 'text' : 'password';
  };

  return (
    <TextField
      type={togglePasswordVisibility()}
      margin="normal"
      required={required}
      fullWidth={fullWidth}
      id={name}
      label={label}
      name={name}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      value={value}
      onChange={onChange}
      error={error}
      InputLabelProps={{
        style: { color: theme.palette.text.primary },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={t('accessibility.TOGGLE_PASSWORD_VISIBILITY')}
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
